'use client'

import { Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import FactBlock from './FactBlock'
import ResponsiveWrapper from '../ReponsiveWrapper'

type Props = {
  showPro: boolean
}

const InfoSection = ({ showPro }: Props) => {
  const translate = useTranslate('trust_and_safety')
  const translatePro = useTranslate('trust_and_safety_pro')

  return (
    <div className="page-section__facts">
      <SeparatedList
        separator={
          <ResponsiveWrapper
            mobile={<Spacer size="x3-large" />}
            desktop={<Spacer size="x5-large" orientation="vertical" />}
          />
        }
      >
        <FactBlock
          title={showPro ? translatePro('buying_tips_title') : translate('buying_tips_title')}
          body={showPro ? translatePro('buying_tips_body') : translate('buying_tips_body')}
          linkText={showPro ? translatePro('buying_tips') : translate('buying_tips')}
        />
        <FactBlock
          title={showPro ? translatePro('selling_tips_title') : translate('selling_tips_title')}
          body={showPro ? translatePro('selling_tips_body') : translate('selling_tips_body')}
          linkText={showPro ? translatePro('selling_tips') : translate('selling_tips')}
        />
      </SeparatedList>
    </div>
  )
}

export default InfoSection
